// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage, isSupported } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfigDevelopment = {
//   apiKey: 'AIzaSyDJriO_gYhjV6_w3Uq0lH9lXIhmlevGf8I',
//   authDomain: 'jmconcrete-c4073.firebaseapp.com',
//   projectId: 'jmconcrete-c4073',
//   storageBucket: 'jmconcrete-c4073.appspot.com',
//   messagingSenderId: '405586817159',
//   appId: '1:405586817159:web:76b607b3ad9f23c3fb0822',
//   measurementId: 'G-2F3THT542F',
// };
const firebaseConfigProduction = {
  apiKey: 'AIzaSyBzyjS1T12Ko3uURyMte94rdyODMj1SdOo',
  authDomain: 'jmc-concrete-b5228.firebaseapp.com',
  projectId: 'jmc-concrete-b5228',
  storageBucket: 'jmc-concrete-b5228.firebasestorage.app',
  messagingSenderId: '385848479218',
  appId: '1:385848479218:web:b1277ac2b089cbc8f72f6b',
  measurementId: 'G-SBEVMR7CS4',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfigProduction);

// getMessaging() throws in browsers that do not support the Messaging SDK (older
// Safari, Firefox private windows). It must never run at module scope, or importing
// this file takes the whole app down on those browsers.
let messagingInstance;

export const getMessagingIfSupported = async () => {
  if (messagingInstance !== undefined) {
    return messagingInstance;
  }
  try {
    messagingInstance = (await isSupported()) ? getMessaging(app) : null;
  } catch (error) {
    console.warn('Firebase messaging is unavailable:', error);
    messagingInstance = null;
  }
  return messagingInstance;
};

/**
 * Subscribe to foreground push messages.
 * Returns an unsubscribe function (a no-op when messaging is unsupported) so callers
 * can tear the listener down — previously each call leaked a listener.
 */
export const subscribeToMessages = (onNotification) => {
  let unsubscribe = null;
  let cancelled = false;

  getMessagingIfSupported().then((messaging) => {
    if (!messaging || cancelled) return;
    unsubscribe = onMessage(messaging, onNotification);
  });

  return () => {
    cancelled = true;
    if (unsubscribe) unsubscribe();
  };
};
